/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__, or convert again using --optional-chaining
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import _ from 'underscore';
import $ from 'jquery';
import moment from 'moment';

import { truncate } from '../utils/truncate.js';

class Marker {
  constructor() {
    this.latitude = null;
    this.longitude = null;
    this.address = null;
    this.title = null;
    this.place_url = null;
    this.events = [];
  }
}

export class Maps {
        constructor(elements) {
          this.markers = [];
          this.maps = [];
          this._markerClicked = this._markerClicked.bind(this);
          if (elements.length > 0) {
            this.map_options = Slzr.Meta['map-options'];

            this._collectData();
            this._initializeMaps(elements);
          }
        }

        _collectData() {
          // Collect the json content for all json-ld tags on the page
          let events = $('script[type="application/ld+json"]').map((index, element) => {
            return JSON.parse(element.text);
        }).get();

          // Only keep events with a location
          events = _.select(events, item => (item['@type'] === 'Event') &&
            ((item['@context'] === 'http://schema.org') || (item['@context'] === 'https://schema.org')) &&
            (__guard__(item.location != null ? item.location.geo : undefined, x => x['@type']) === 'GeoCoordinates'));

          // Sort by date
          events = _.sortBy(events, item => [item['startDate'], item['name']]);

          // And deduplicate it to get the unique events on this page
          //
          // This leaves the earliest instance of each event in the list
          events = _.unique(events, false, item => item['url']);

          // Now, we need to cluster it by location
          events = _.groupBy(events, item => {
            return [__guard__(item.location != null ? item.location.geo : undefined, x => x.latitude), __guard__(item.location != null ? item.location.geo : undefined, x1 => x1.longitude)];
        });

          // Create a marker for each
          this.markers = [];
          return _.each(events, (location_events, location) => {
            if (__guard__(location_events[0].location != null ? location_events[0].location.geo : undefined, x => x.latitude) != null) {
              // Find the best event's location for labelling the marker
              let best_location = _.sortBy(location_events, item => (__guard__(item.location != null ? item.location.geo : undefined, x1 => x1.latitude) ? 1 : 0) +
                ((item.location != null ? item.location.address : undefined) ? 1 : 0) +
                ((item.location != null ? item.location.url : undefined) ? 1 : 0));
              best_location = best_location[0];

              const marker = new Marker();
              marker.latitude = best_location.location.geo.latitude;
              marker.longitude = best_location.location.geo.longitude;
              marker.address = best_location.location.address;
              marker.title = best_location.location.name;
              marker.place_url = best_location.location.url;
              marker.events = location_events;
              return this.markers.push(marker);
            }
          });
        }

        // Callback for a map marker being clicked
        //
        // +map+ is the google map instance
        // +marker+ is the Marker instance representing which marker was clicked
        // +google_marker+ is the google maps marker clicked
        _markerClicked(map, marker, google_marker) {
          const event_links = [];

          for (const event of Array.from(marker.events.slice(0, 5))) {
            const event_date = moment(event['startDate']).format('M/D');
            event_links.push(`<p><span class=\"event-date\">${event_date}</span> <a href=\"${event.url}\">${truncate(event.name, 60)}</a></p>`);
          }

          const contents = `\
<div>
  <div class="event-date">${marker.title}</div>
  <p>${marker.address}</p>
  <p></p>
  ${event_links.join('')}
</div>\
`;

          if (!this.infoWindow) { this.infoWindow = new google.maps.InfoWindow({maxWidth: 200}); }
          this.infoWindow.setContent(contents);
          return this.infoWindow.open(map, google_marker);
        }


        // Initialize the map on the provided element, creating markers and such
        _initializeMap(element) {
          const map_options = _.assign({}, this.map_options, {
            element,
            points: []
          });
          const map = new Slzr.Maps.Map(map_options);

          return (() => {
            const result = [];
            for (const marker of Array.from(this.markers)) {
              const google_marker = map.addMarker(marker.latitude, marker.longitude);
              result.push(google_marker.addListener('click', this._markerClicked.bind(this, map, marker, google_marker)));
            }
            return result;
          })();
        }

        // Initialize the specified list of map elements on the page
        _initializeMaps(elements) {
          const my = this;
          return elements.each(function() { return my._initializeMap(this); });
        }

}

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}